import Coreka from './Coreka'

export default Coreka
